export default {
  textField: {
    color: "secondary",
    filled: true,
    class: "input",
    // style: ""
  },
};
